import React from "react";
import FolderClosedIcon from "@atlaskit/icon/core/folder-closed";
import Button from "@atlaskit/button/new";
import { token } from "@atlaskit/tokens";
import FlowGroupNameSelect, { FLOW_GROUP_NAME_PLACEHOLDER } from "../components/FlowGroupNameSelect";

const FlowGroupNameEditor = ({
  value,
  onChange,
  onPrimaryAction,
  onSecondaryAction,
  primaryLabel = "Save",
  secondaryLabel = "Clear",
}) => {
  return (
    <div style={{ minWidth: `${FLOW_GROUP_NAME_PLACEHOLDER.length}ch` }}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
        <FolderClosedIcon label="Group name" />
        <strong style={{ color: token("color.text", "#172b4d") }}>Group name</strong>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <div style={{ flex: 1 }}>
          <FlowGroupNameSelect value={value} onChange={onChange} />
        </div>
        <Button appearance="subtle" onClick={onSecondaryAction}>
          {secondaryLabel}
        </Button>
        <Button appearance="primary" onClick={onPrimaryAction}>
          {primaryLabel}
        </Button>
      </div>
    </div>
  );
};

export default FlowGroupNameEditor;
